export enum CardEnum {
    Unknown,
    GoalsCard,
    Tasks,
    MotivationCard,
    View360,
    PowerBiReports,
    RmsPortal,
    UserProfile,
    GlobalNotes,
}
